/* This file was GENERATED from the Webflow capture, which has since been
 * retired — see DESIGN-SYSTEM-PLAN.md. There is no generator any more: this is
 * now ordinary source, and editing it by hand is how you change it.
 * One copy for all 59 routes. Column headings levelled to <h6>.
 * Ported element-for-element from mirror/sales/index.html. Internal links are
 * NavLink so `w--current` and `aria-current` follow the route.
 */
import { NavLink } from 'react-router'
import { wfActive } from '@/components/chrome/wf-active'

export function FooterMarkup() {
  return (
      <footer className={"footer section-container dark"}>
        <div className={"section-wrapper stack footer-wrapper"}>
          <div className={"w-layout-grid footer-grid"}>
            <div id={"w-node-_7c32794f-570e-7360-5b1c-02a4473b2816-473b2812"} className={"footer-item"}>
              <a href={"#"} className={"wbs-footer-logo-wrap w-inline-block"}>
                <img src={"/media/66fd7eaea30ed321717cb6c1_Singulate-logo.svg"} loading={"lazy"} alt="" className={"wbs-footer-logo"} />
              </a>
              <p className={"footer-blurb"}>
                Every email, written for the person reading it. For marketing teams, and now anyone with a list.
              </p>
            </div>
            <div id={"w-node-_7c32794f-570e-7360-5b1c-02a4473b281b-473b2812"} className={"footer-item"}>
              <h6 className={"footer-title"}>
                Product
              </h6>
              <div className={"wbs-footer-links"}>
                <NavLink to={"/ai-email-editor"} className={wfActive("footer-link")}>
                  AI Email Platform
                </NavLink>
                <NavLink to={"/hubspot-integration"} className={wfActive("footer-link")}>
                  HubSpot Integration
                </NavLink>
                <NavLink to={"/marketing-automation"} className={wfActive("footer-link")}>
                  Marketing Automation
                </NavLink>
                <NavLink to={"/studio"} className={wfActive("footer-link")}>
                  Singulate Studio
                </NavLink>
                <NavLink to={"/pricing"} className={wfActive("footer-link")}>
                  Pricing
                </NavLink>
                <NavLink to={"/demo"} className={wfActive("footer-link")}>
                  Book Demo
                </NavLink>
              </div>
            </div>
            <div id={"w-node-_7c32794f-570e-7360-5b1c-02a4473b282d-473b2812"} className={"footer-item"}>
              <h6 className={"footer-title"}>
                Resources
              </h6>
              <div className={"wbs-footer-links"}>
                <NavLink to={"/blog"} className={wfActive("footer-link")}>
                  Blog
                </NavLink>
                <NavLink to={"/newsletter"} className={wfActive("footer-link")}>
                  Newsletter
                </NavLink>
                <NavLink to={"/sendhelp"} className={wfActive("footer-link")}>
                  Live Sessions: Send Help
                </NavLink>
                <a href={"https://singulate.notion.site/"} target={"_blank"} className={"footer-link"}>
                  Knowledgebase
                </a>
                <NavLink to={"/modular-communication-strategy-architecture-whitepaper"} className={wfActive("footer-link")}>
                  Whitepaper
                </NavLink>
                <NavLink to={"/roi-calculator"} className={wfActive("footer-link")}>
                  Pricing Calculator
                </NavLink>
                <NavLink to={"/hubspot-nurture-agent-vs-singulate"} className={wfActive("footer-link")}>
                  Nurture Agent vs. Singulate
                </NavLink>
              </div>
            </div>
            <div id={"w-node-_7c32794f-570e-7360-5b1c-02a4473b283f-473b2812"} className={"footer-item"}>
              <h6 className={"footer-title"}>
                Company
              </h6>
              <div className={"wbs-footer-links"}>
                <NavLink to={"/about"} className={wfActive("footer-link")}>
                  About
                </NavLink>
                <NavLink to={"/singulate-certified-partner-program"} className={wfActive("footer-link")}>
                  Partner Program
                </NavLink>
                <a href={"https://app.vanta.com/singulate/trust/s77awike6j7no037hyfxa"} target={"_blank"} className={"footer-link"}>
                  Trust Center
                </a>
                <NavLink to={"/terms"} className={wfActive("footer-link")}>
                  Terms of Service
                </NavLink>
                <NavLink to={"/privacy"} className={wfActive("footer-link")}>
                  Privacy Policy
                </NavLink>
              </div>
            </div>
          </div>
          <div className={"footer-bottom"}>
            <p className={"footer-copyright"}>
              © Singulate, Inc. All rights reserved.
            </p>
            <div className={"footer-social-links"}>
              <a href={"https://www.youtube.com/@singulate-ai"} target={"_blank"} className={"footer-social-link w-inline-block"}>
                <img src={"/media/670422959c9f66fd53d5cb60_youtube-icon.svg"} loading={"eager"} alt="" className={"footer-social-icon small"} />
              </a>
              <a href={"https://www.linkedin.com/company/singulate-ai"} target={"_blank"} className={"footer-social-link w-inline-block"}>
                <img src={"/media/670422b19c9f66fd53d5ee4d_linkedin.svg"} loading={"eager"} alt="" className={"footer-social-icon"} />
              </a>
              <a href={"https://x.com/singulate_ai"} target={"_blank"} className={"footer-social-link w-inline-block"}>
                <img src={"/media/670422efbf13aeb7140ae9c7_twitter.svg"} loading={"eager"} alt="" className={"footer-social-icon small"} />
              </a>
            </div>
          </div>
        </div>
      </footer>
  )
}
